!<template>
  <div class="router-header flex flex-wrap items-center">
    <div class="content-area__heading">
      <vs-button
        radius
        @click.stop="back()"
        class="float-left mr-2"
        type="border"
        icon-pack="feather"
        icon="icon-arrow-left"
      ></vs-button>

      <span class="font">{{ users.title }}</span>
    </div>
    <!-- <div class="ml-auto md:block">
            <vs-button color="danger" icon-pack="feather">Deactivate</vs-button>
        </div> -->
    <vx-card class="mt-4">
      <vs-tabs vs-alignment="fixed">
        <vs-tab :label="$t('labels.c_details')">
          <vs-row vs-w="12">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-avatar class="mx-auto" size="100px" :src="users.image" />
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <h2>{{ users.title }}</h2>
              <p>{{ users.location | address_format }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-divider></vs-divider>
          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.Category") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.code }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.class_fee") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.fees }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.description") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.description }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
        </vs-tab>
        <vs-tab :label="$t('labels.host_details')">
          <vs-row vs-w="12" class="mb-3">
            <vs-row vs-w="12">
              <vs-col
                vs-justify="center"
                vs-align="center"
                vs-lg="2"
                vs-sm="4"
                vs-xs="12"
              >
                <vs-avatar
                  class="mx-auto"
                  size="100px"
                  :src="users.profile_pic"
                />
              </vs-col>
              <vs-col
                vs-justify="center"
                vs-align="center"
                vs-lg="8"
                vs-sm="4"
                vs-xs="12"
                class="mt-auto mb-auto"
              >
                <h2>{{ users.name }}</h2>
              </vs-col>
              <vs-col
                vs-type="flex"
                vs-justify="center"
                vs-align="center"
                vs-lg="2"
                vs-sm="4"
                vs-xs="12"
              >
                <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
              </vs-col>
            </vs-row>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.id") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.id }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>

          <!-- <vs-row vs-w="12" class="mb-3" >
                    <vs-col vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12" >
                        <p><b>{{ $t('labels.host_name') }} :</b></p>
                    </vs-col>
                    <vs-col vs-justify="center" vs-align="center" vs-lg="8" vs-sm="4" vs-xs="12" class="mt-auto mb-auto">
                       <p>{{users.name}}</p>
                    </vs-col>
                    <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="2" vs-sm="4" vs-xs="12">
                        <!-- vs-lg="2" vs-sm="4" vs-xs="12"
                    </vs-col>
                </vs-row> -->

          <vs-row vs-w="12" class="mb-3">
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <p>
                <b>{{ $t("labels.email") }} :</b>
              </p>
            </vs-col>
            <vs-col
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="4"
              vs-xs="12"
              class="mt-auto mb-auto"
            >
              <p>{{ users.email }}</p>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
              <!-- vs-lg="2" vs-sm="4" vs-xs="12" -->
            </vs-col>
          </vs-row>
        </vs-tab>
        <vs-tab :label="$t('labels.attendees')">
          <vs-table max-items="10" stripe :data="bookers">
            <template slot="thead">
              <vs-th>{{ $t("labels.profile_pic") }}</vs-th>
              <vs-th>{{ $t("labels.name") }}</vs-th>
              <vs-th>{{ $t("labels.email") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="data[indextr].profile_pic">
                  <vs-avatar
                    @click="userDetails(data[indextr].id, data[indextr].role)"
                    class="mx-auto"
                    size="100px"
                    :src="data[indextr].profile_pic"
                  />
                </vs-td>

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].name }}
                </vs-td>

                <vs-td :data="data[indextr].email">
                  {{ data[indextr].email }}
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vs-tab>

        <!-- <vs-tab :label="$t('labels.reported_details')">
					<vs-table max-items="10" stripe :data="reports">
                    <template slot="thead">
                        <vs-th>{{ $t('labels.profile_pic') }}</vs-th>
                        <vs-th>{{ $t('labels.name') }}</vs-th>
                        <vs-th>{{ $t('labels.email') }}</vs-th>
                    </template>

                    <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].profile_pic">
                        <vs-avatar class="mx-auto" size="100px" :src="users.profile_pic" />
                        </vs-td>
                        
                        <vs-td :data="data[indextr].name">
                        {{ data[indextr].name }}
                        </vs-td>

                        <vs-td :data="data[indextr].email">
                        {{ data[indextr].email }}
                        </vs-td>
                    </vs-tr>
                    </template>
                    
                    </vs-table>
				</vs-tab> -->
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    users: [],
    bookers: [],
    reports: [],
    apple: 0,
    facebook: 0,
    google: 0,
    routing: "",
    page: null,
  }),
  methods: {
    getClassDetails() {
      axios
        .get("class/getClassById/" + this.$route.params.id)
        .then((response) => {
          // let data = response.data.data;
          this.users = response.data.data;
          if (this.users.type == "ON") {
            this.routing = "Online_Classes";
          } else {
            this.routing = "Offline_Classes";
          }
          console.log(this.users);
        })
        .catch((err) => console.log(err.response));
    },
    getUserDetails() {
      axios
        .get("class/getClassBookings/" + this.$route.params.id)
        .then((response) => {
          // let data = response.data.data;
          this.bookers = response.data.data;
          console.log(this.bookers);
        })
        .catch((err) => console.log(err.response));
    },
    userDetails(id, type) {
      if (type == "T") {
        this.$router.push({ name: "TeachersById", params: { id: id } });
      }
      if (type == "S") {
        this.$router.push({ name: "StudentsById", params: { id: id } });
      }
    },
    back() {
      if (this.page) {
        this.$router.push({ name: this.routing, query: { page: this.page } });
        // this.$router.push({name: "Students",params:{page:this.page}});
      } else {
        history.back();
      }
    },
  },
  mounted() {
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
    this.getClassDetails();
    this.getUserDetails();
  },
};
</script>

<style lang="scss" scoped>
</style>